import { Box, Divider, type BoxProps } from '@mui/material'
import { SearchIndexField } from '__generated__/graphql'
import { type FC } from 'react'
import { useRosterSearch } from 'recruiter/hooks'
import { FilterAccordionLabel } from 'recruiter/pages/Research/Filters'
import { Accordion } from 'shared/components/Accordion'
import {
    RosterCandidateProcessStatusFilter,
    RosterCompanyFilter,
    RosterCreatedByFilter,
    RosterCreationDateFilter,
    RosterIndustryFilter,
    RosterInternalUserFilter,
    RosterLocationFilter,
    RosterQuickSearchFilter,
    RosterSectorFilter,
    RosterStartDateFilter,
    RosterStatusFilter,
    RosterTitleFilter,
    RosterTypeFilter,
} from './Roster'

interface RosterFiltersProps extends BoxProps {}

export const RosterFilters: FC<RosterFiltersProps> = ({ ...props }) => {
    const { tableState } = useRosterSearch()

    return (
        <Box flex="1" overflow="auto" {...props}>
            <RosterQuickSearchFilter />

            <Divider />

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterCompany
                        )}
                        filterName="Company"
                    />
                }
            >
                <RosterCompanyFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterCreatedBy
                        )}
                        filterName="Created By"
                    />
                }
            >
                <RosterCreatedByFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterCreatedAt
                        )}
                        filterName="Creation Date"
                    />
                }
            >
                <RosterCreationDateFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterIndustries
                        )}
                        filterName="Industry"
                    />
                }
            >
                <RosterIndustryFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterInternalUsers
                        )}
                        filterName="Internal User"
                    />
                }
            >
                <RosterInternalUserFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterGeoLocations
                        )}
                        filterName="Location"
                    />
                }
            >
                <RosterLocationFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterSectors
                        )}
                        filterName="Sector"
                    />
                }
            >
                <RosterSectorFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterStartDate
                        )}
                        filterName="Start Date"
                    />
                }
            >
                <RosterStartDateFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterStatus
                        )}
                        filterName="Status"
                    />
                }
            >
                <RosterStatusFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet ===
                                SearchIndexField.RosterCandidateProcessStatus
                        )}
                        filterName="Process Status"
                    />
                }
            >
                <RosterCandidateProcessStatusFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) =>
                                facet === SearchIndexField.RosterTitles
                        )}
                        filterName="Title"
                    />
                }
            >
                <RosterTitleFilter />
            </Accordion>

            <Accordion
                label={
                    <FilterAccordionLabel
                        showDirtyDot={tableState.filters.some(
                            ({ facet }) => facet === SearchIndexField.RosterType
                        )}
                        filterName="Type"
                    />
                }
            >
                <RosterTypeFilter />
            </Accordion>
        </Box>
    )
}
